import { useMemo } from 'react';

import { useReservoirTokensData } from '@pkg/hooks';

import { useWalletStore } from '@app/store/zustand';

export type MarketStatusProps = {
    contractAddress: string;
    tokenId: string;
};

export const useMarketStatus = ({ contractAddress, tokenId }: MarketStatusProps) => {
    const { data: collectionData } = useReservoirTokensData({
        tokens: [`${contractAddress}:${tokenId}`],
    });

    const wallets = useWalletStore((state) => state.connectedWallets.map((item) => item.walletAddress));

    const isOwner = useMemo(
        () =>
            collectionData?.tokens?.[0]?.token?.owner &&
            wallets.some(
                (wallet) =>
                    collectionData?.tokens?.[0]?.token?.owner?.toLowerCase() ===
                    wallet.toLowerCase().substring(wallet.indexOf('.') + 1),
            ),
        [collectionData, wallets],
    );

    const isListed = useMemo(() => Boolean(collectionData?.tokens?.[0]?.market?.floorAsk?.id), [collectionData]);
    const hasPendingOffers = useMemo(() => Boolean(collectionData?.tokens?.[0]?.market?.topBid?.id), [collectionData]);

    // TODO: Identify if user has placed an offer
    const hasOffered = false;

    return {
        isListed,
        isOwner,
        hasOffered,
        hasPendingOffers,
        loaded: Boolean(collectionData),
    };
};
